import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid
} from '@mui/material';

export const AddCourseStepModal = ({ showadd, handleCloseAdd, lngsltd, newStepData, handleStepNumberChange, stepNumberError, setNewStepData, handleSave }) => {
  return (
    <Dialog 
      open={showadd} 
      onClose={handleCloseAdd} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)'
        }
      }}
    >
      <DialogTitle 
        sx={{ 
          background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
          color: 'white',
          fontWeight: 700,
          fontSize: { xs: '1.1rem', sm: '1.25rem' },
          py: { xs: 2, sm: 2.5 }
        }}
      >
        {lngsltd["Add a new step"]}
      </DialogTitle>
      <DialogContent sx={{ pt: { xs: 2, sm: 3 } }}>
        <Grid container spacing={2}> 
          <Grid item xs={12}>
            <TextField
              type="number"
              fullWidth
              label="Course Number"
              variant="outlined"
              value={newStepData.courseNumber}
              disabled
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                  '&.Mui-disabled': {
                    backgroundColor: '#f5f5f5'
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type="text"
              fullWidth
              label="Step Number"
              variant="outlined"
              placeholder="Enter Step Number"
              value={newStepData.stepNumber}
              onChange={handleStepNumberChange}
              error={!!stepNumberError}
              helperText={stepNumberError}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px'
                }
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type="text"
              fullWidth
              label="Step Title"
              variant="outlined"
              placeholder="Enter Step Title"
              value={newStepData.stepTitle}
              onChange={(e) => setNewStepData(prevData => ({ ...prevData, stepTitle: e.target.value }))}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px'
                }
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: { xs: 2, sm: 3 }, pb: { xs: 2, sm: 3 }, gap: 1 }}>
        <Button 
          variant="outlined" 
          onClick={handleCloseAdd}
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 500,
            px: 3,
            borderColor: '#6c757d',
            color: '#6c757d',
            '&:hover': {
              borderColor: '#5a6268',
              backgroundColor: 'rgba(108, 117, 125, 0.05)'
            }
          }}
        >
          {lngsltd["Close"]}
        </Button>
        <Button 
          onClick={handleSave} 
          variant="contained"
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
            boxShadow: '0 4px 12px rgba(220, 53, 69, 0.35)',
            '&:hover': {
              background: 'linear-gradient(135deg, #c82333 0%, #bd2130 100%)',
              boxShadow: '0 6px 16px rgba(220, 53, 69, 0.45)'
            }
          }}
        >
          {lngsltd["Add Step"]}
        </Button>
      </DialogActions>
    </Dialog>
  );
};